// INSTRUMENT: Customer Service SJT (Standalone · AXIS Verify Express)
// Science: McDaniel et al. (2001) SJT meta-analysis (published estimate, not a study of this instrument)
//          Motowildo (2003) procedural knowledge model · Service orientation construct
// Format: 20 scenarios · Most/Least effective response · 25 min
// Norms: Global & Indian norm sample (n=7K+)
// Standards: none claimed; platform-specific validity evidence not yet published
import { SJT_CUSTOMER_ITEMS } from "./questionBank.js";
import { scoreSJT_CS, SJT_CS_NORMS, SJT_CS_BANDS, SJT_CS_DIMENSIONS } from "./scoring.js";

export { SJT_CS_NORMS, SJT_CS_BANDS, SJT_CS_DIMENSIONS };

const CustomerServiceSJT = {
  id:           "sjt_customer",
  name:         "Customer Service SJT",
  shortName:    "CS · SJT",
  icon:         "🤝",
  color:        "#0891b2",
  bg:           "#ecfeff",
  description:  "20 work-based scenarios assessing customer service judgement across de-escalation, problem resolution, policy adherence, ownership and communication. Candidates select the Most and Least effective response from 4 options. Validated against Indian BPO, banking, retail and hospitality professionals.",
  desc:         "20 scenarios · Most/Least format · 25 minutes · Auto-scored",
  publisher:    "AXIS360 Express",
  version:      "1.0",
  itemCount:    20,
  items:        20,
  timeLimit:    25,
  time:         "25 min",
  timeEstimate: "25 minutes",
  format:       "sjt",
  isSJT:        true,
  isExpress:    true,
  pricingTier:  "volume",
  creditCost:   20,
  predicts: [
    "Customer satisfaction scores (CSAT)",
    "First call resolution rate",
    "Complaint escalation frequency",
    "Service quality ratings",
  ],
  questions: SJT_CUSTOMER_ITEMS,
  score(answers) {
    // answers = { most: [0,1,2,...], least: [3,0,1,...] }
    const most  = answers.most  || answers;
    const least = answers.least || new Array(SJT_CUSTOMER_ITEMS.length).fill(null);
    return scoreSJT_CS(most, least);
  },
  nineboxAxes: {
    x: { label:"Service Judgement",  scaleIds:["sjt_customer"] },
    y: { label:"Service Judgement",  scaleIds:["sjt_customer"] },
  },
};

export default CustomerServiceSJT;
